import _asyncToGenerator from "/home/runner/work/AluPriser.dk/AluPriser.dk/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/AluPriser.dk/AluPriser.dk/node_modules/@babel/runtime/regenerator";
import { isArrayBuffer } from "@aws-sdk/is-array-buffer";
import { toHex } from "@aws-sdk/util-hex-encoding";
import { SHA256_HEADER, UNSIGNED_PAYLOAD } from "./constants";
export var getPayloadHash = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, hashConstructor) {
    var headers, body, _i, _Object$keys, headerName, hashCtor;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = _ref.headers, body = _ref.body;
            _i = 0, _Object$keys = Object.keys(headers);

          case 2:
            if (!(_i < _Object$keys.length)) {
              _context.next = 9;
              break;
            }

            headerName = _Object$keys[_i];

            if (!(headerName.toLowerCase() === SHA256_HEADER)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", headers[headerName]);

          case 6:
            _i++;
            _context.next = 2;
            break;

          case 9:
            if (!(body == undefined)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855");

          case 13:
            if (!(typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer(body))) {
              _context.next = 21;
              break;
            }

            hashCtor = new hashConstructor();
            hashCtor.update(body);
            _context.t0 = toHex;
            _context.next = 19;
            return hashCtor.digest();

          case 19:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));

          case 21:
            return _context.abrupt("return", UNSIGNED_PAYLOAD);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getPayloadHash(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();